export default function DateToString(date) {
    
    if (!date || date === "" || date === undefined) {
        return undefined
    } else {
        var month = pad2(date.getMonth() + 1);
        var day = pad2(date.getDate());
        var year = date.getFullYear();

        return day + "/" + month + "/" + year;
    }

}

function pad2(n) {
    return (n < 10 ? '0' : '') + n;
}